import type { IntlShape } from 'react-intl'

export function getContentPrinciples(intl: IntlShape) {
  return [
    {
      image: {
        src: 'https://cdn.sanity.io/images/dnsgqii5/production/4d115b62313a15bd7d6c0e3ed1fa1840a8e7eede-601x600.png',
        alt: intl.formatMessage({
          id: 'about.page.principles.imageAlt1',
          defaultMessage: 'Deep care. Deep trust.',
        }),
      },
      title: intl.formatMessage({
        id: 'about.page.principles.title1',
        defaultMessage: 'Deep care. Deep trust.',
      }),
      content: intl.formatMessage({
        id: 'about.page.principles.content1',
        defaultMessage:
          'We care deeply about our work and trust our teammates to do the same. We care about our customers, about shipping only greatness, and about our impact on the community.',
      }),
    },
    {
      image: {
        src: 'https://cdn.sanity.io/images/dnsgqii5/production/80c77d2cac12aff367f8f17f511372e0c9c5c89d-601x601.png',
        alt: intl.formatMessage({
          id: 'about.page.principles.imageAlt2',
          defaultMessage: 'Extremely professional & extremely personal.',
        }),
      },
      title: intl.formatMessage({
        id: 'about.page.principles.title2',
        defaultMessage: 'Extremely professional & extremely personal.',
      }),
      content: intl.formatMessage({
        id: 'about.page.principles.content2',
        defaultMessage:
          'The best way to build strong relationships in any workplace is to do meaningful work. Trust and respect are timezone-independent.',
      }),
    },
    {
      image: {
        src: 'https://cdn.sanity.io/images/dnsgqii5/production/ab06d70057bb0796f2d17d2637704b42e74704f0-601x601.png',
        alt: intl.formatMessage({
          id: 'about.page.principles.imageAlt3',
          defaultMessage: 'Ship loudly.',
        }),
      },
      title: intl.formatMessage({
        id: 'about.page.principles.title3',
        defaultMessage: 'Ship loudly.',
      }),
      content: intl.formatMessage({
        id: 'about.page.principles.content3',
        defaultMessage:
          "Remote requires you to promote yourself and your work more than you may be used to. Don't be afraid to speak up, repeat yourself, and ask others to amplify your voice. Amplify theirs, too.",
      }),
    },
    {
      image: {
        src: 'https://cdn.sanity.io/images/dnsgqii5/production/6fe695d97628fd2004a74f6e0e3a3aa8584b541d-601x601.png',
        alt: intl.formatMessage({
          id: 'about.page.principles.imageAlt4',
          defaultMessage: 'We all sweep the floor.',
        }),
      },
      title: intl.formatMessage({
        id: 'about.page.principles.title4',
        defaultMessage: 'We all sweep the floor.',
      }),
      content: intl.formatMessage({
        id: 'about.page.principles.content4',
        defaultMessage:
          'We have a doer mentality. We are not afraid to cross boundaries and to get things done when they need to be. We push ourselves. If something is broken, we fix it rather than complain. We give direct feedback.',
      }),
    },
  ]
}
